import { Moment } from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { API_DATE_FORMAT } from 'components/atoms/due-date-picker';
import { Form } from 'components/atoms/form';
import { ProjectTemplateOption } from 'queries/templates/project-templates';
import { EstimatedDueDate } from './estimated-due-date';

type NamePath = string | number | (string | number)[];
interface Props {
  startDateFieldNamePath: NamePath;
  sourceFieldNamePath: NamePath;
}
export const DueDateFormItem: FC<Props> = ({
  startDateFieldNamePath,
  sourceFieldNamePath,
}) => {
  return (
    <Form.Item
      shouldUpdate
      label={<FormattedMessage id="projects.phase.import.due_date" />}
      tooltip={<FormattedMessage id="projects.create.due_date.duration" />}
    >
      {({ getFieldValue }) => {
        const startDate: Moment | undefined = getFieldValue(
          startDateFieldNamePath,
        );

        const template: ProjectTemplateOption | undefined =
          getFieldValue(sourceFieldNamePath);

        return (
          <EstimatedDueDate
            data={{
              startDate: startDate?.format(API_DATE_FORMAT),
              templateId: template?.value,
            }}
          />
        );
      }}
    </Form.Item>
  );
};
